/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Player
 */
export interface Player {
    /**
     * 
     * @type {Date}
     * @memberof Player
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    lookupId: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    id: string;
}

/**
 * Check if a given object implements the Player interface.
 */
export function instanceOfPlayer(value: object): value is Player {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('lookupId' in value) || value['lookupId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PlayerFromJSON(json: any): Player {
    return PlayerFromJSONTyped(json, false);
}

export function PlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Player {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'customerId': json['customerId'],
        'lookupId': json['lookupId'],
        'id': json['id'],
    };
}

export function PlayerToJSON(value?: Player | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'customerId': value['customerId'],
        'lookupId': value['lookupId'],
        'id': value['id'],
    };
}

